import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import File from 'Entity/File';

import _LikeButton from 'Components/Listing/Item/_LikeButton';
import _LikedUserListModal from './_LikedUserListModal';

interface LikeSectionProps {
    canEdit: boolean;
    changeStateOnEdit?: (status: boolean) => void;
    file: File;
}

export interface User {
    email: string;
    name: string;
}

const LikeSection: React.FC<LikeSectionProps> = ({
    canEdit,
    changeStateOnEdit,
    file,
}) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const favoriesPropertySlug = file.hasOwnProperty('favorisPropertyEnabled') && file.favorisPropertyEnabled?.slug;
    const [likedUsers, setLikedUsers] = useState<User[]>(file[favoriesPropertySlug] || []);

    const updateLikes = (email: string, name: string) => {
        setLikedUsers((prev: User[]) =>
            prev.some((user) => user.email === email)
                ? prev.filter((user) => user.email !== email)
                : [...prev, { email, name }]
        );
    };

    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
    };

    return (
        <>
            <_LikeButton
                canEdit={canEdit}
                changeStateOnEdit={changeStateOnEdit}
                favoriesPropertySlug={favoriesPropertySlug}
                file={file}
                updateLikes={updateLikes}
            />

            <button className={`btn d-flex ${likedUsers.length < 1 ? 'disabled' : ''}`} onClick={handleShowModal}>
                <u>
                    {t('app.file.viewLikes')}
                </u>
            </button>

            {showModal && (
                <_LikedUserListModal
                    likes={likedUsers}
                    onClose={handleCloseModal}
                />
            )}
        </>
    );
};

export default LikeSection;
